import { apiSlice } from '../../store/api/apiSlice';

/**
 * Login endpoints migrated from the Angular `AuthenticationService`
 * (src/app/services/authentication.service.ts):
 *
 *  - `elogin()`          -> POST {loginApiBaseUrl}/api/elogin
 *  - `forgotPassword()`  -> POST {apiBaseUrl}/api/FrgtPswTrkCUD
 *
 * Headers are handled centrally by `dynamicBaseQuery`, which attaches the
 * rotating `AuthorizationKey` and the stored `Token`. Angular instead sent the
 * static `EMIS@2019_api` key through its HTTP interceptor. If the login gateway
 * you point at still expects that static key, pass it per endpoint via
 * `headers: { Authorization: 'EMIS@2019_api' }` - baseQuery spreads endpoint
 * headers last, so they win.
 */

export interface EloginRequest {
  userName: string;
  password: string;
  /** Angular's `cnType` argument. The counselling app always sends 1. */
  cnType?: number;
}

export interface EloginResponse {
  dataStatus: boolean;
  message?: string;
  records?: {
    token: string;
    [key: string]: unknown;
  };
}

export interface ForgotPasswordRequest {
  /** '1' = School, '2' = Teacher */
  userType: string;
  userName: string;
}

export interface ForgotPasswordResponse {
  dataStatus?: boolean;
  message?: string;
  [key: string]: unknown;
}

export const loginApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    elogin: builder.mutation<EloginResponse, EloginRequest>({
      query: ({ userName, password, cnType = 1 }) => ({
        url: 'login',
        method: 'POST',
        body: {
          records: {
            emis_username: userName,
            emis_password: password,
            IsCnsl: cnType,
          },
        },
        service: 'login',
      }),
      invalidatesTags: ['Auth'],
    }),

    forgotPassword: builder.mutation<
      ForgotPasswordResponse,
      ForgotPasswordRequest
    >({
      query: ({ userType, userName }) => ({
        url: 'api/FrgtPswTrkCUD',
        method: 'POST',
        // Same record shape Angular's `showLogin()` posted.
        body: {
          records: {
            IndexId: '',
            UserType: userType,
            UserId: userName,
            Name: '',
            Ref: '',
            Email: '',
            ApproveStatus: '',
            ApproverUsername: '',
            RejectRsn: '',
          },
        },
        // Angular routed this through `DataService`, i.e. environment.apiBaseUrl.
        service: 'api',
      }),
    }),
  }),
});

export const { useEloginMutation, useForgotPasswordMutation } = loginApi;
